import React, { useContext, useState } from 'react';

import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Jumbotron,
  Spinner,
  Image,
} from 'react-bootstrap';
import {AuthLogin} from '../utils/NewAuthService';
import UtechLogo from '../images/UtechLogo.png';
import { storeContext } from '../Store/storeContext';
import LoadingPage from './LoadingPage';
import { useHistory } from 'react-router-dom';
export const AdminLogin = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLogged, setLogging] = useState(false);
  const [state, dispatch] = useContext(storeContext);
  const history = useHistory()
  
  const login = (event) => {
    event.preventDefault();
    setLogging(true);
    AuthLogin(email, password)
      .then((response) => {
        if(response.data.user.role ==='admin'){
          setLogging(false)
          setErrorMessage("Student Login Only");
        }
       else{
        localStorage.setItem('user',JSON.stringify(response.data.user));
        localStorage.setItem('tokens',JSON.stringify(response.data.tokens));
        window.location.href = '/sepratecourses';
       }
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
        setLogging(false);
      });
  };

  return (
    <div>
        <Container fluid className='bg-custom min-vh-100'>
          <Row className='justify-content-center p-3'>
            <Col md={6} className='my-auto'>
              <Jumbotron className='form-pannel align-middle shadow-lg'>
                <div className='d-flex justify-content-center p-2'>
                  <Image
                    className='text-center'
                    src={UtechLogo}
                    width='100px'
                    height='83px'
                  />
                </div>
                <h2>Utech Login Form</h2>
                <p className='pt-2 text-center'>
                  Please enter your email and password
                </p>
                <Form onSubmit={login} className='form-custom px-4'>
                  <Form.Group controlId='formBasicEmail'>
                    <Form.Control
                      required
                      onChange={(event) => setEmail(event.target.value)}
                      type='email'
                      placeholder='Email Address'
                    />
                  </Form.Group>
                  <Form.Group controlId='formBasicPassword'>
                    <Form.Control
                      required
                      onChange={(event) => setPassword(event.target.value)}
                      type='password'
                      placeholder='Password'
                    />
                  </Form.Group>
                  <Form.Group>
                    <a
                      rel='noreferrer'
                      target='_blank'
                      className='forgetPassword'
                      href='mailto:utechofficial@gmail.com'
                    >
                      Forget Password ?
                    </a>
                  </Form.Group>
                  <Form.Group>
                    <p className='text-danger'>{errorMessage}</p>
                  </Form.Group>
                  <Button disabled={isLogged} variant='inherit' type='submit'>
                    {isLogged ? (
                      <Spinner size='sm' animation='border'></Spinner>
                    ) : (
                      'LOGIN'
                    )}
                  </Button>
                </Form>

                {/* <p className='text-center alert-danger p-1'>
                  Students who have joined UTECH before 15th December are
                  advisied to login from the old portal.
                </p>
                <center>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://utech-file-upload.web.app/'
                  >
                    <strong>OLD STUDENT PORTAL</strong>
                  </a>
                </center> */}
              </Jumbotron>
            </Col>
          </Row>
        </Container>
    </div>
  );
};
